import FormLegalName from "@components/inputs/FormLegalName";
import OnboardingDialogLayout from "@components/layouts/Onboarding/components/OnboardDialogLayout";
import { OnboardingDialogStep } from "@components/utils/OnboardingDialog/constants/onboarding-steps";
import { OnboardingStepProps } from "@components/utils/OnboardingDialog/types";
import { closeOnboardingDialog } from "@components/utils/OnboardingDialog/utils";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

interface LegalNameStepProps extends OnboardingStepProps {
  onUpdateSuccess?: () => void;
  step?: OnboardingDialogStep;
}

const LegalNameStep = ({ handleClose, onUpdateSuccess, layout, step, handleBack }: LegalNameStepProps) => {
  const { t } = useTranslation();

  const handleOnUpdateSuccess = useCallback(() => {
    closeOnboardingDialog();
    onUpdateSuccess?.();
  }, [onUpdateSuccess]);

  return (
    <OnboardingDialogLayout
      layout={layout}
      drawerTitle={t("full name")}
      drawerSubTitle={t("enter your full name")}
      pageTitle={t("full name")}
      pageSubTitle={t("enter your full name")}
      navigation={{
        close: {
          onClick: handleClose,
        },
        back: {
          onClick: handleBack,
        },
      }}
      features={{
        showCloseButton: true,
        showBackButton: !!handleBack,
      }}
    >
      <FormLegalName
        onUpdateSuccess={handleOnUpdateSuccess}
        mode={
          [OnboardingDialogStep.UpdateLegalName, OnboardingDialogStep.UpdateBankLegalName].includes(
            step as OnboardingDialogStep,
          )
            ? "update"
            : "add"
        }
      />
    </OnboardingDialogLayout>
  );
};

export default LegalNameStep;
